var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-input',{attrs:{"title":"客户手机","placeholder":"非必填，11位数字","type":"tel","max":_vm.maxLength},on:{"on-change":_vm.changeValue},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }